var vertical_embed_viewer_default = {
  "card": "uF4S0",
  "slimLayout": "_9SiYs",
  "cardLayout": "mzh9S",
  "imageContainer": "aP19A",
  "image": "WMB4Y",
  "content": "uTOoZ"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
